import { CLEAR_COUPON, GET_COUPON_END, PlanActions } from "./actions";
import { PlanState } from "./state";

import { cleanErrorMessage } from "components/Notifications";

export function planReducer(state: PlanState = {}, action: PlanActions): PlanState {
    switch (action.type) {
        case CLEAR_COUPON:
            return {
                ...state,
                coupon: undefined,
                couponError: undefined
            };
        case GET_COUPON_END:
            const { coupon, error } = action.payload;
            const couponError = error ? cleanErrorMessage(error.message) : "";

            return { coupon, couponError };
        default:
            return state;
    }
}
